// eslint-disable-next-line import/no-extraneous-dependencies
import { EnvironmentConfig } from '@olxeu-a2b/delivery-utils/typings/config';
import cookie from '@olxeu-a2b/delivery-utils/src/extras/cookie';

function getCookieFlag(flagName: string): string {
  let cookieFlag = cookie.get(`ff-${flagName}`);

  if (process.env.A2B_ENV === 'localhost') {
    const laquesisFFCookie = cookie.get('laquesisff');
    const isLaquesisFlag = flagName.slice(0, 2) === 'lq';

    if (isLaquesisFlag && laquesisFFCookie) {
      cookieFlag = laquesisFFCookie.includes(flagName.slice(3, flagName.length)).toString();
    }
  }

  return cookieFlag;
}

export default function getParsedFlagsForEnvironment(
  featureFlags: EnvironmentConfig['featureFlags'] = {},
): EnvironmentConfig['featureFlags'] {
  return Object.keys(featureFlags).reduce((finalFlagConfig, flagName) => {
    const cookieFlag = getCookieFlag(flagName);

    if (cookieFlag === null) {
      return finalFlagConfig;
    }
    return {
      ...finalFlagConfig,
      [flagName]: cookieFlag === 'true',
    };
  }, featureFlags);
}
